import { create } from 'zustand'
import { useCustomer, useStaff } from './useSession'
import { useUpdates } from 'expo-updates'

export const useUpdateModalState = create<{
  isForced: boolean
  setForced: (state: boolean) => void
}>((set) => ({
  isForced: false,
  setForced: (state) => set({ isForced: state }),
}))

const useUpdateModal = () => {
  const { isForced, setForced } = useUpdateModalState()
  const staff = useStaff()
  const customer = useCustomer()
  const updates = useUpdates()

  return {
    isOpen: updates.isUpdatePending && !staff && !customer,
    isForced,
    setForced,
  }
}

export default useUpdateModal
